import { NotificationActionTypes } from './actions';
import Constants from './constants';

const initialState = {};

const ACTION_HANDLERS = {
  [NotificationActionTypes.REMOVE_NOTIFICATION]: () => ({}),
  [NotificationActionTypes.ADD_NOTIFICATION]: (state, action) =>
    Object.assign({}, state, {
      message: action.message,
      level: action.level,
    }),
};

export function notificationReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}

export default {
  name: Constants.MODULE_NAME,
  reducer: notificationReducer,
};
